
import register from '~/mixins/common/pages/register'
export default {
    name: 'Register',
    mixins: [register],
    middleware: 'auth',
    data: () => ({
        registerModal: false,
    }),
    mounted() {
        this.registerModal = true
    },
    methods: {
        doClickOutsize() {
            this.$router.push('/')
        },
    },
}
